module.exports = __webpack_public_path__ + "ki.80e19e9b.svg";